import { NavigationTitle } from './links';

export const getLinkVisibility = (
  link: string,
  {
    hasAuctions,
    hasArtists,
    hasNews,
    hasCurators,
    hasSelections,
  }: { hasAuctions: boolean; hasArtists: boolean; hasNews: boolean; hasCurators: boolean; hasSelections: boolean },
) => {
  if (link === NavigationTitle.Auctions) {
    return hasAuctions;
  }

  if (link === NavigationTitle.Artists) {
    return hasArtists;
  }

  if (link === NavigationTitle.News) {
    return hasNews;
  }

  if (link === NavigationTitle.Curators) {
    return hasCurators;
  }

  if (link === NavigationTitle.Selections) {
    return hasSelections;
  }

  return true;
};
